<template>
  <div id="SectionPlatform">
    <UIContainer>
      <SectionTitle class="SectionPlatform__title">
        <template #title> Why work with us? </template>
      </SectionTitle>

      <UILearnMoreCards :cards="cards" />
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UILearnMoreCards from '@/views/components/ui/cards/UILearnMoreCards.vue'
import cardPlatform from '../assets/workWithUs/cardPlatform.avif'
import cardConsulting from '../assets/workWithUs/cardConsulting.avif'
import bcorp from '../assets/workWithUs/bcorpCert.avif'

const cards = [
  {
    image: bcorp,
    title: 'Academy',
    description:
      'Empower your team with the knowledge to lead your sustainability initiatives. Our academy offers courses designed and taught by industry-leading experts.',
    gradientTo: 'rgba(239, 241, 245, 1)',
    backgroundColor: 'rgba(239, 241, 245, 1)',
  },
  {
    image: cardConsulting,
    title: 'Consulting',
    description:
      'Get expert guidance to define your strategy and navigate the complexities of ESG compliance. We turn your ambition into an actionable, board-ready roadmap.',
    gradientTo: 'rgba(239, 241, 245, 1)',
    backgroundColor: 'rgba(239, 241, 245, 1)',
  },
  {
    image: cardPlatform,
    title: 'Platform',
    description:
      'Automate your ESG data management on a single, audit-ready platform. Go from scattered data to a governed, single source of truth with confidence.',
    gradientTo: 'rgba(255, 255, 255, 0.95)',
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
]
</script>

<style lang="scss" scoped>
#SectionPlatform {
  .SectionPlatform__title {
    max-width: 48rem;
    text-align: center;
    margin: 0 auto 4rem;
  }

  .SectionPlatform__cards {
    margin-top: 4rem; // spacing before cards grid
  }
}
</style>
